import { FreightRate } from "./freight-rate.model";
import { RouteMapper } from "../../../route/route.mapper";
import { RateMapper } from "../../../rate/rate.mapper";
import { BaseLinkedRate } from "../../../rate/rate-base-linked.model";

export class FreightRateMapper {
  public static map(response: any): FreightRate {
    return new FreightRate(
      <BaseLinkedRate>RateMapper.map(response.rate),
      RouteMapper.map(response.route),
      response.rate.flatRateRoute,
      response.rate.pickupRateRouteId,
      response.rate.deliveryRateRouteId,
      response.rate.restrictedNote,
      response.rate.failedRestrictions,
      response.rate.originLocation?.location?.identity,
      response.rate.destinationLocation?.location?.identity,
      undefined,
      undefined,
      response.rate.validityNote,
    );
  }
}
